// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-answer-card-correction-default{margin:0 auto 20px;text-align:center}.plv-iar-answer-card-correction-default__text{font-size:14px;color:#333;text-align:center;line-height:1}.plv-iar-answer-card-correction-default__text p{display:inline}.plv-iar-answer-card-correction-default__text ::v-deep span{color:#45acff;font-size:18px;font-weight:600}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
